import {
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useState } from "react";
import { useFormIscrizione } from "../FormContext";

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%&()<>,.;:_])[A-Za-z\d!$%&()<>,.;:_]{8,16}$/;

const Credenziali = ({ errors }) => {
  const { formState, dispatch } = useFormIscrizione();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h8" gutterBottom>
          La password deve contenere:
          <ul>
            <li>minimo 8 caratteri (massimo 16)</li>
            <li>almeno una maiuscola</li>
            <li>almeno una minuscola</li>
            <li>almeno un numero</li>
            <li>
              almeno un carattere speciale tra questi: ! $ % & ( ) &lt; &gt; , .
              ; : _
            </li>
          </ul>
        </Typography>
        <Box display="flex" flexDirection="column" gap={4} mt={3}>
          <Grid container spacing={2}>
            <Grid item sm={3} xs={12}>
              <TextField
                label="Email"
                id="email-credenziali"
                name="email-credenziali"
                fullWidth
                required
                value={formState.credenziali.email}
                onChange={(e) =>
                  dispatch({
                    type: "set_credenziali",
                    payload: { email: e.target.value },
                  })
                }
                error={Boolean(errors.credenziali?.email)}
                helperText={errors.credenziali?.email}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                label="Password"
                id="password-credenziali"
                name="password-credenziali"
                fullWidth
                required
                type={showPassword ? "text" : "password"}
                value={formState.credenziali.password}
                onChange={(e) =>
                  dispatch({
                    type: "set_credenziali",
                    payload: { password: e.target.value },
                  })
                }
                error={Boolean(errors.credenziali?.password)}
                helperText={errors.credenziali?.password}
                inputProps={{
                  maxLength: 16,
                  autoComplete: "new-password",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((v) => !v)}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                label="Conferma password"
                id="conferma-password-credenziali"
                name="conferma-password-credenziali"
                fullWidth
                required
                type={showConfirm ? "text" : "password"}
                value={formState.credenziali.confermaPassword || ""}
                onChange={(e) =>
                  dispatch({
                    type: "set_credenziali",
                    payload: { confermaPassword: e.target.value },
                  })
                }
                error={Boolean(errors.credenziali?.confermaPassword)}
                helperText={errors.credenziali?.confermaPassword}
                inputProps={{
                  maxLength: 16,
                  autoComplete: "new-password",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirm((v) => !v)}
                        edge="end"
                      >
                        {showConfirm ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Credenziali;
